{
  "name": "aurelius-web",
  "version": "1.0.0",
  "workspaces": [
    "projects/ui"
  ],
  "scripts": {
    "ng": "ng",
    "start": "ng serve main-app --port 4201 --host 0.0.0.0 --configuration local --allowed-hosts all --disable-host-check",
    "start:vendor-app": "ng serve vendor-app --port 4202 --host 0.0.0.0 --configuration local --allowed-hosts all --disable-host-check",
    "build:vendor-app": "ng build vendor-app --configuration development",
    "start-bak": "ng serve --port 4201 --host 0.0.0.0 --configuration local --hmr",
    "build:main-app": "ng build main-app --configuration development",
    "build-qa:main-app": "ng build main-app --configuration QA",
    "build-prod:main-app": "ng build main-app --configuration pro2",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "lint": "ng lint"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^18.2.14",
    "@angular/cdk": "^18.2.2",
    "@angular/common": "^18.2.14",
    "@angular/compiler": "^18.2.14",
    "@angular/core": "^18.2.14",
    "@angular/forms": "^18.2.14",
    "@angular/platform-browser": "^18.2.14",
    "@angular/platform-browser-dynamic": "^18.2.14",
    "@angular/router": "^18.2.14",
    "@ctrl/ngx-emoji-mart": "^9.3.0",
    "@fortawesome/fontawesome-free": "^6.5.1",
    "@fullcalendar/angular": "^6.1.15",
    "@fullcalendar/core": "^6.1.15",
    "@fullcalendar/daygrid": "^6.1.15",
    "@fullcalendar/interaction": "^6.1.15",
    "@fullcalendar/timegrid": "^6.1.15",
    "@ngx-translate/core": "^15.0.0",
    "@stomp/stompjs": "^7.3.0",
    "@tweenjs/tween.js": "^25.0.0",
    "animate.css": "^4.1.1",
    "apexcharts": "^5.10.4",
    "chart.js": "^4.4.9",
    "chartjs-chart-geo": "^4.3.4",
    "clientjs": "^0.2.1",
    "d3": "^7.8.5",
    "dayjs": "^1.11.13",
    "detectincognitojs": "^1.3.7",
    "echarts": "^6.0.0",
    "grapesjs": "^0.22.6",
    "grapesjs-preset-newsletter": "^1.0.2",
    "libphonenumber-js": "^1.12.40",
    "lodash-es": "^4.17.21",
    "ng-select2-component": "^14.0.1",
    "ngx-toastr": "^19.0.0",
    "prettier": "^3.2.5",
    "primeicons": "^6.0.1",
    "primeng": "^17.10.0",
    "rxjs": "~7.8.0",
    "three": "^0.176.0",
    "topojson-client": "^3.1.0",
    "tslib": "^2.8.1",
    "zone.js": "~0.14.10"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^18.2.21",
    "@angular-eslint/builder": "17.3.0",
    "@angular-eslint/eslint-plugin": "17.3.0",
    "@angular-eslint/eslint-plugin-template": "17.3.0",
    "@angular-eslint/schematics": "17.3.0",
    "@angular-eslint/template-parser": "17.3.0",
    "@angular/cli": "~18.2.21",
    "@angular/compiler-cli": "^18.2.14",
    "@eslint/js": "^9.1.1",
    "@regru/eslint-plugin-prefer-early-return": "^1.0.0",
    "@types/clientjs": "^0.2.2",
    "@types/d3": "^7.4.0",
    "@types/jasmine": "~4.3.0",
    "@types/lodash-es": "^4.17.12",
    "@types/three": "^0.176.0",
    "@typescript-eslint/eslint-plugin": "7.2.0",
    "@typescript-eslint/parser": "7.2.0",
    "autoprefixer": "^10.4.21",
    "eslint": "^8.57.0",
    "eslint-plugin-fp": "^2.3.0",
    "eslint-plugin-jasmine": "^4.1.3",
    "eslint-plugin-jsdoc": "^48.2.3",
    "eslint-plugin-prefer-class-properties": "^1.0.0",
    "eslint-plugin-rxjs": "^5.0.3",
    "eslint-plugin-sonarjs": "^0.25.1",
    "globals": "^15.0.0",
    "jasmine-core": "~4.6.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "ng-packagr": "^18.2.1",
    "postcss": "^8.5.3",
    "tailwindcss": "^3.4.17",
    "typescript": "~5.4.2",
    "typescript-eslint": "^7.7.1"
  },
  "optionalDependencies": {
    "@esbuild/linux-x64": "0.23.0",
    "@nx/nx-linux-x64-gnu": "18.3.5",
    "@rollup/rollup-linux-x64-gnu": "4.22.4"
  }
}
